var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoApprove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 186.1 186.1",
    style: {
      enableBackground: "new 0 0 186.1 186.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#064B93;}\n\t.st1{fill:#1794CD;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#004B93;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st4{enable-background:new    ;}\n\t.st5{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.75;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_797",
    transform: "translate(0 0.148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo-Approve"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1425",
    className: "st0",
    d: "M0,110.5h186.1v59.3c0,8.9-7.2,16.2-16.2,16.2l0,0H16.2C7.3,186,0,178.7,0,169.8l0,0 V110.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1426",
    className: "st1",
    d: "M186.1,110.5H0v-92C0,8.2,8.3-0.1,18.6-0.1l0,0h148.9c10.3,0,18.6,8.3,18.6,18.6l0,0 V110.5L186.1,110.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1452",
    className: "st2",
    d: "M103,25.4c11.4,1.8,22,6.7,30.7,14.3c-2.6,2.4-5.2,4.9-7.6,7.4C104.3,29,71.9,32,53.8,53.8 s-15.1,54.2,6.7,72.3s54.2,15.1,72.3-6.7c9.9-11.9,13.9-27.6,10.8-42.8c3.1-2.1,6.2-4,9.5-5.7c8.7,33.1-11,67-44.1,75.8 c-33.1,8.7-67-11-75.8-44.1s11-67,44.1-75.8C85.8,24.5,94.5,24.1,103,25.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1453",
    className: "st3",
    d: "M58,73.3c7.4-5.3,15.8-8.9,24.7-10.6c5.8,9.2,10.6,21.6,11.5,29.8 c19.8-25.6,44.6-57.4,67.9-62.1c-4.1,10.8-6.4,22.2-6.8,33.7c-25.1,7.4-49,35.9-65.4,55C84,103.7,73.4,80.9,58,73.3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "AP"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M76.2,126.4l18.1,42.8h-6.1L83,156.9H63.9l-5.1,12.3h-6.1l18.1-42.8H76.2z M66.2,151.3h14.4l-7.2-17 L66.2,151.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M118.9,126.4c2,0,4,0.4,5.8,1.2c1.8,0.8,3.4,1.8,4.7,3.2s2.4,2.9,3.2,4.7s1.2,3.7,1.2,5.8 c0,2.1-0.4,4-1.2,5.8c-0.8,1.8-1.9,3.4-3.2,4.7s-2.9,2.4-4.7,3.2c-1.8,0.8-3.7,1.2-5.8,1.2h-11.1v13H102v-42.8H118.9z  M118.9,150.6c1.3,0,2.4-0.2,3.6-0.7c1.1-0.5,2.1-1.2,2.9-2c0.8-0.8,1.5-1.8,2-2.9c0.5-1.1,0.7-2.3,0.7-3.6 c0-1.3-0.2-2.5-0.7-3.6c-0.5-1.1-1.1-2.1-2-2.9c-0.8-0.8-1.8-1.5-2.9-2c-1.1-0.5-2.3-0.7-3.6-0.7h-11.1v18.5H118.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoApprove);
export default __webpack_public_path__ + "static/media/Logo-Approve.82b98969feb5628da1cd17259490998e.svg";
export { ForwardRef as ReactComponent };